import axios from "./userInstance";

interface UpdateUserRolesPayload {
  auth0_user_id: string;
  roles: string[];
}

export default async (payload: UpdateUserRolesPayload) => {
  const response = await axios.post(`/users/roles/v2`, payload);
  return response.data || true
}
